/* eslint-disable */
import { ISDSIcon } from "@sznds/icons";
import { ISDSIconMulti } from "~/interfaces";
import { icon, node } from "~/util/dom";
import { linkToNewWindow } from "~/util/userweb";
import createSDSIcon from "./icon";

interface IIconActionProps {
	icon: string;
	sdsIcon?: ISDSIcon | ISDSIconMulti;
	title: string;
	callback: (event: Event) => void;
	href: string;
	small: boolean;
	attention: boolean;
	change: boolean;
	log: boolean;
	ownLog: (element: HTMLElement) => void;
}

const DEFAULT_PROPS: IIconActionProps = {
	icon: "",
	sdsIcon: null,
	title: "",
	callback: e => {},
	href: "",
	small: false,
	attention: false,
	change: false,
	log: true,
	ownLog: null,
};

export default class IconAction {
	#container: HTMLDivElement;
	#props: IIconActionProps;

	constructor(props) {
		this.#container = node("div", { className: "icon-action" });
		this.#container.addEventListener("click", this, false);
		this.props = props;
	}

	destroy() {
		this.#container.removeEventListener("click", this, false);
	}

	get container() {
		return this.#container;
	}

	set props(props) {
		this.#props = Object.assign({}, DEFAULT_PROPS, props);
		this._build();
	}

	set updateProps(props: IIconActionProps) {
		Object.assign(this.#props, props);
		this._build();
	}

	get props() {
		return Object.assign({}, this.#props);
	}

	handleEvent(event) {
		if (!linkToNewWindow(event)) {
			event.preventDefault();
			this.#props.callback(event);
		}
	}

	_build() {
		this.#container.innerHTML = "";

		const button = this.#props.href ? node("a", { href: this.#props.href }) : node("button", { type: "button" });
		button.classList[this.#props.attention ? "add" : "remove"]("attention");
		button.classList[this.#props.change ? "add" : "remove"]("change");

		if (this.#props.sdsIcon) {
			button.appendChild(createSDSIcon({ symbol: this.#props.sdsIcon }));
		} else {
			button.appendChild(icon(this.#props.icon));
		}

		if (this.#props.small) {
			this.#container.classList.add("small");
		} else {
			this.#container.classList.remove("small");
			button.insertAdjacentHTML("beforeend", `<span>${this.#props.title}</span>`);
		}
		this.#container.appendChild(button);
		this.#container.title = this.#props.title;
		if (!this.#props.log) {
			button.setAttribute("data-log-ignore", "1");
		}
		if (typeof this.#props.ownLog === "function") {
			button.addEventListener("pointerdown", e => {
				this.#props.ownLog(button);
			});
		}
	}
}
